var map = {
	"./Face-Analysis.png": 200,
	"./Face-search.png": 201,
	"./faceAddWithColletion.png": 202,
	"./face_compare.png": 203,
	"./label_detect.png": 204,
	"./rekognition-text-detection.png": 205,
	"./worker-with-bb.png": 206
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 199;